module.exports = __webpack_public_path__ + "img/ic_chao_qian.9341663d.png";